import script from "./MainwavePickerView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainwavePickerView.vue?vue&type=script&setup=true&lang=js"

import "./MainwavePickerView.vue?vue&type=style&index=0&id=38de8732&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38de8732"]])

export default __exports__